export default "__VITE_ASSET__096b5623__"